import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(({ spacing, typography, layout }) => ({
  footer: {
    padding: spacing(2),
  },
  logo: {
    height: layout.logo.height,
    width: 'auto',
  },
  legal: {
    fontFamily: typography.fontFamily,
    fontSize: typography.subtitle1.fontSize,
  },
}))

export default useStyles
